import React from 'react';
import {Button} from 'antd';

class AisinoButton extends React.Component {

    render() {
        return(
            <Button {...this.props} size={this.props.size?this.props.size:"small"}/>
        );
    }
}
export default AisinoButton;